import React from 'react';
import { AD_LIGHT_BOOTSTRAP_SCRIPT, AD_LIGHT_CRITICAL_CSS } from '@benzinga/ads-utils';

export const AD_LIGHT_BOOTSTRAP_SCRIPT_ID = 'bz-adlight-bootstrap';
export const AD_LIGHT_CRITICAL_CSS_ID = 'bz-adlight-critical-css';

export const AdLightBootstrapScript: React.FC = () => (
  <>
    <style
      // eslint-disable-next-line benzinga/no-unsanitized-innerhtml -- static CSS from ads-utils; sanitizeHTML is for HTML and would corrupt CSS
      dangerouslySetInnerHTML={{ __html: AD_LIGHT_CRITICAL_CSS }}
      id={AD_LIGHT_CRITICAL_CSS_ID}
    />
    <script
      // eslint-disable-next-line benzinga/no-unsanitized-innerhtml -- static JS bootstrap from ads-utils; sanitizeHTML is for HTML and would corrupt JS
      dangerouslySetInnerHTML={{ __html: AD_LIGHT_BOOTSTRAP_SCRIPT }}
      data-cfasync="false"
      id={AD_LIGHT_BOOTSTRAP_SCRIPT_ID}
    />
  </>
);
